/**
 * O visual das tabelas de cotação, num lugar só.
 *
 * Uma cotação tem 59 linhas e até catorze colunas de cor. Sem divisória
 * vertical e sem faixa alternada, o olho lê a tabela como uma lista de frases
 * corridas — foi o retorno do comprador na primeira versão. O cabeçalho ganha
 * fundo e borda dupla para separar claramente o rótulo do dado.
 */
export const CABECALHO =
  'border-b-2 border-border bg-surface-subtle text-[11px] uppercase tracking-wide text-ink-soft';

export const TITULO_COLUNA = 'px-sm py-sm font-bold border-r border-border last:border-r-0';

/**
 * Cabeçalho que gruda logo abaixo da barra do topo enquanto a página rola.
 * Grudar exige que a moldura não role de lado, então só a partir de xl — em
 * tela estreita ela rola e o cabeçalho grudaria dentro dela, por cima das
 * primeiras linhas. Vai no `<thead>`, com a moldura em `xl:overflow-visible`.
 */
export const CABECALHO_FIXO = 'z-20 text-[11px] uppercase tracking-wide text-ink-soft xl:sticky xl:top-[var(--altura-barra,54px)]';

/**
 * Célula fixa perde a borda da tabela ao rolar: a divisória e a borda dupla
 * vêm de sombra interna. O fundo fica na célula, e não na linha, para os
 * cantos arredondados acompanharem a moldura.
 */
export const TITULO_COLUNA_FIXO =
  'bg-surface-subtle px-sm py-sm font-bold shadow-[inset_-1px_-2px_0_var(--color-border)] first:rounded-tl-lg last:rounded-tr-lg last:shadow-[inset_0_-2px_0_var(--color-border)]';

export const LINHA = 'border-b border-border last:border-0 even:bg-dominant hover:bg-surface-subtle';

export const CELULA = 'px-sm py-xs border-r border-border last:border-r-0';

/**
 * O nome do cabo é a coluna que se lê primeiro; quebrado em três linhas, some
 * no meio das colunas de cor. Prefere-se rolar a tabela de lado a espremê-lo.
 */
export const COLUNA_PRODUTO = 'min-w-[230px]';

/** Colunas de cor são estreitas e sempre numéricas. */
export const CELULA_COR = 'px-xs py-xs text-right tabular-nums border-r border-border last:border-r-0';
